import SignupProvider from '@jetshop/core/components/Auth/signup-context'
import useAuth from '@jetshop/core/components/AuthContext/useAuth'
// import t from '@jetshop/intl'
import React from 'react'
import { Redirect } from 'react-router'
import LoadingPage from '../../LoadingPage'
import { useShopConfig } from '@jetshop/core/hooks/useShopConfig'
import { useIntl } from '@jetshop/intl'
import {
   PageBanner as SignUpBanner,
   AuthPageHeaderTitle as SignUpBannerTitle,
} from '../UI/authPages'
import SignUpForm from './SignUpForm'

function SignUpPage() {
   const { loggedIn } = useAuth()
   const { routes } = useShopConfig()
   const t = useIntl()

   if (loggedIn) {
      return <Redirect to={routes.myPages.path} />
   }

   return (
      <SignupProvider LoadingComponent={<LoadingPage />}>
         {/* <SignUpBanner>
            <SignUpBannerTitle className="py-32 px-64">
               {t('register account')}
            </SignUpBannerTitle>
         </SignUpBanner> */}
         {/* <Address className="mb-64" />
         <LoginFields />
         <Preferences />
         <SubmitSignUp /> */}
         <SignUpForm />
      </SignupProvider>
   )
}

export default SignUpPage
